import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'
import SEO from "../../seo"
import Layout from '../../layout'
import ItemBody from './ItemBody'
import ItemTop from '../../SingleComponents/ItemTop'
import SideBar from '../../PageComponents/SideBar'
import MoreItems from './MoreItems'
import { capetalize } from '../../../helpers'
import { TextSide, Inner } from '../../styles/inner-sidebar-single'
 
const categoryTitle = {
  restaurants: "restaurant",
  massage: "erotic massage salon",
  stripclubs: "strip club",
  nightclubs: "nightclub"
}

class SingleItemTemplate extends React.Component {
  render() {
    const { pageContext, data } = this.props

    const post = data.mongodbTrendymoscowItems
    const { name, city, slug, location, description } = post
    const { address, coordinates } = location
    const [ lng, lat ] = coordinates
    const { previous, next, category } = pageContext

    const marker = [
      {
        position: { lat, lng },
        name,
        address,
        slug,
        city
      }
    ]
 
    const { position } = marker[0];
    const { schedule, ...rest } = post

    const metaDescription = description.replace(/[<p>/]/g, "").split(' ').slice(0, 25).join(' ')

    return (
      <Layout >
        <SEO title={`${name} ${categoryTitle[category]} in ${capetalize(city)} - our review, phone, photo, address and schedule`}
                  description={metaDescription}
                  canonical={`${slug}/`}/>
          <InnerSingleTop>
            <ItemTop position={position} marker={marker} city={city} slug={slug} title={name}/>
          </InnerSingleTop>

        <Inner narrow="true">
        <TextSide narrow="true">
          <LandingGrid>
              <ItemBody post={rest} />
              <Wrap>
                <MoreItems previous={previous} next={next} header={`More ${category} in Moscow`}/>
              </Wrap>
            </LandingGrid>

            <SideBar schedule={schedule} />
          </TextSide>
        </Inner>
      </Layout>
    )
  } 
} 

const Wrap = styled.div`
  margin: 0 auto 2rem;
  padding: 2rem;
  grid-column: span 2;
  @media (max-width: 850px) {
    grid-column: span 1;
  }
`;

const InnerSingleTop = styled.div`
  max-height: 400px;
  position: relative;
`;

const LandingGrid = styled.main`
`;


export default SingleItemTemplate

export const pageQuery = graphql`
  query ItemBySlug($slug: String!) {
    site {
      siteMetadata {
        title,
      }
    }

    mongodbTrendymoscowItems (slug: {eq: $slug}) {
      name
      city
      description
      subway
      schedule{
        monday { open close}
        tuesday { open close}
        wednesday { open close}
        thursday { open close}
        friday { open close}
        saturday { open close}
        sunday { open close}
      }
      location {
        address
        coordinates
      }
      phone
      url
      image
      slug
    }

  }

`